module.exports = __webpack_public_path__ + "img/IMG_8958.c565ee94.jpg";